//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Light',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
      },
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log('form', form);
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log('flag', flag);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        if ((form.item1 / form.item2) > 0.5) {
          console.log(1111);
          result = true
        }
        if ((form.item3 / form.item4) > 0.6) {
          console.log(2222);
          result = true
        }
        if (form.item3 > (form.item5 * (2 / 3))) {
          console.log(3333);
          result = true
        }
        if (result) {
          self.text = '渗出液可能'
        } else {
          self.text = '漏出液可能'
        }
        self.hasScore = true
        return String(self.text)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Light.vue